import Vue from 'vue'
import Vuex from 'vuex'

import { 
  CHANGE_NEW_REQUESTS,
  CHANGE_REQUESTS_FILTER,
  CHANGE_MODELS_FILTER,
  CHANGE_CLIENT_ARTICLES,
  SET_CLIENT_MALEMODELS,
  SET_CLIENT_FEMALEMODELS,
  SET_ALGOLIA_CLIENT
} from './mutations-names'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    newRequests: 0,
    adminRequestsFilter: 'creationDate',
    adminModelsFilter: 'all',
    adminAlgoliaClient: null,
    clientArticles: [],
    clientFemaleModels: [],
    clientLastFemaleDoc: null,
    clientMaleModels: [],
    clientLastMaleDoc: null,
  },
  mutations: {
    [CHANGE_NEW_REQUESTS] (state, n) {
      state.newRequests = n
    },
    [CHANGE_REQUESTS_FILTER] (state, value) {
      state.adminRequestsFilter = value
    },
    [CHANGE_MODELS_FILTER] (state, value) {
      state.adminModelsFilter = value
    },
    [CHANGE_CLIENT_ARTICLES] (state, articles) {
      state.clientArticles = articles
    },
    [SET_CLIENT_MALEMODELS] (state, payload) {
      state.clientMaleModels = payload.models
      state.clientLastMaleDoc = payload.lastDoc
    },
    [SET_CLIENT_FEMALEMODELS] (state, payload) {
      state.clientFemaleModels = payload.models
      state.clientLastFemaleDoc = payload.lastDoc
    },
    [SET_ALGOLIA_CLIENT] (state, client) {
      state.adminAlgoliaClient = client
    }
  },
  actions: {
  },
})
